import { Handle, Position } from '@xyflow/react';
import { CButton } from '@coreui/react';
import { useCallback } from 'react';
import { X } from 'lucide-react'; // icona per la X di eliminazione card
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';

const CardLinkNode = ({ id, data }) => {

  const handleDeleteClick = useCallback((e) => {
    e.stopPropagation();
    if (data.onDelete) data.onDelete(id);
  }, [data, id]);

  const navigate = useNavigate();

  if (!data.node.recommended) {
    return (

      <div style={{
        padding: '10px',
        border: '3px solid #ff4de6',
        boxShadow: '0 0 30px #ff4de6',
        borderRadius: '15px',
        backgroundColor: 'var(--background-card-color)',
        textAlign: 'center',
      }}>
        {/* pulsante X per eliminare */}
        <button
          onClick={handleDeleteClick}
          style={{
            position: 'absolute',
            top: '12px',
            right: '12px',
            background: 'transparent',
            border: 'none',
            color: '#ff4de6',

            cursor: 'pointer',
          }}
          title="Elimina nodo"
        >
          <X size={13} />
        </button>
        <p style={{ color: 'white', borderBottom: '1px solid #ff4de6', fontWeight: '700'}}>{data.node.title}</p>

        <CButton
          style={{
            borderRadius: '15px',
            backgroundColor: '#ff4de6'
          }}
          className='text-uppercase text-white'
          size="sm"
          onClick={() => {
            const parentNumericId = data.parentId?.split('-')[0]?.replace('n', '') || '';
            navigate(`/new-app/${parentNumericId}/${data.node.id}/edit-cardlink`);
          }}
        >
          {t('button.edit')}
        </CButton>

        {/* Handles per connettere i nodi */}
        <Handle type="target" position={Position.Top} />

      </div>

    );
  } else {
    return (
      <div style={{
        padding: '10px',
        border: '3px solid #f0b900',
        boxShadow: '0 0 30px #f0b900',
        borderRadius: '15px',
        backgroundColor: 'var(--background-card-color)',
        textAlign: 'center',
      }}>
        {/* pulsante X per eliminare */}
        <button
          onClick={handleDeleteClick}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: 'transparent',
            border: 'none',
            color: '#ffca1bff',
            cursor: 'pointer',
          }}
          title="Elimina nodo"
        >
          <X size={13} />
        </button>
        <p style={{ color: 'white', borderBottom: '1px solid #f0b900' }}>🌟 {data.node.title}</p>

        <CButton
          style={{
            borderRadius: '15px',
            backgroundColor: '#f0b900'
          }}
          className='text-uppercase text-white'
          size="sm"
          onClick={() => {
            const parentNumericId = data.parentId?.split('-')[0]?.replace('n', '') || '';
            navigate(`/new-app/${parentNumericId}/${data.node.id}/edit-cardlink`);
          }}


        >
          {t('button.edit')}
        </CButton>

        {/* Handles per connettere i nodi */}
        <Handle type="target" position={Position.Top} />

      </div>
    );
  }
};

export default CardLinkNode;
